import React from "react";
import { Switch, Route } from "react-router-dom";
import Main from "../containers/mainContainer"

function RouterMenuAuthorization() {
    return (
        <Route path="/MenuAuthorization">
            <Switch>
                <Route path="/MenuAuthorization" exact>
                    <Main />
                </Route>
                <Route path="/MenuAuthorization/Main" exact>
                    <Main />
                </Route>
            </Switch>
        </Route>
    );
}
export default RouterMenuAuthorization;
